import { GET_LOG_CONTENT } from '../../constants/actions/policy';

export function getLogContent(payload) {
    return {
        type: GET_LOG_CONTENT,
        payload,
    };
}
